import { render, staticRenderFns } from "./MyGrade.vue?vue&type=template&id=c0459c48&scoped=true"
import script from "./MyGrade.vue?vue&type=script&lang=js"
export * from "./MyGrade.vue?vue&type=script&lang=js"
import style0 from "./MyGrade.vue?vue&type=style&index=0&id=c0459c48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0459c48",
  null
  
)

export default component.exports